import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["name", "componentConfigurations"];
var _componentMap;
import React from 'react';
import { ELEGANT_ENHANCEMENTS, SOOTHING_SERENITY, TRANQUIL_TOUCH, ElegantEnhancements, SoothingSerenity, TranquilTouch } from './variants';
import { ComponentConfigurationPropType } from '../../types';
import './CuratedHero.less';
var defaultProps = {
  componentConfigurations: []
};
var componentMap = (_componentMap = {}, _defineProperty(_componentMap, ELEGANT_ENHANCEMENTS, ElegantEnhancements), _defineProperty(_componentMap, SOOTHING_SERENITY, SoothingSerenity), _defineProperty(_componentMap, TRANQUIL_TOUCH, TranquilTouch), _componentMap);
export default function CuratedHero(_ref) {
  var name = _ref.name,
    componentConfigurations = _ref.componentConfigurations,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Component = componentMap[name || ''];
  if (!Component) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    componentConfigurations: componentConfigurations
  }, rest));
}
CuratedHero.defaultProps = defaultProps;